export default __webpack_public_path__ + "static/media/customerio.b943b7bf.png";